import { useEffect, useState } from "react";
import "./App.css";
import Today from "./components/Today";
import ProgressBar from "./components/ProgressBar";
import AddTask from "./components/AddTask";
import { TasksContext } from "./Tasks";
import TodayTaskList from "./components/TodayTaskList";
import TomorrowTaskList from "./components/TomorrowTaskList";

function App() {
  const [tasks, setTasks] = useState(() => {
    try {
      const existing = JSON.parse(localStorage.getItem("tasks"));

      if (existing) {
        return existing;
      } else {
        return [];
      }
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(tasks));
    // localStorage.clear();
  }, [tasks]);

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    setInterval(() => {
      setTime(new Date());
    }, 5000);
  }, []);

  return (
    <TasksContext.Provider value={[tasks, setTasks]}>
      <div className="App">
        <header className="App-header">
          <Today time={time}></Today>
        </header>

        {/* Section component for progress bar */}
        <ProgressBar></ProgressBar>

        {/* Section component for new tasks */}
        <AddTask></AddTask>

        {/* Section component for today's tasks */}
        <TodayTaskList></TodayTaskList>

        {/* Section component for tomorrow's tasks */}
        <TomorrowTaskList></TomorrowTaskList>
      </div>
    </TasksContext.Provider>
  );
}

export default App;
